import { Store } from 'redux';
import { State } from './store';
import {
  transformListFromSIdToId,
  transformListFromIdToSId,
} from 'services/transformListBetweenIdSId';

const STORAGE_KEY = 'chameleon_v2';

let localStorageStateBookmark: string;

export const setLocalStorageStateBookmark = location => {
  localStorageStateBookmark = location;
};

if (window.location.hash.match('clear')) {
  const location = window.location.href.replace(/#.*$/, '');

  sessionStorage.clear();
  localStorage.clear();

  window.open(location, '_self');
}

export const saveState = (store: Store) => () => {
  const state = { ...store.getState() };

  // Clear the undesired properties from the store
  delete state.focusedNodeId;
  delete state.lastFocusedNodeId;
  delete state.currentInteractionBlockId;

  delete state.currentInteraction;

  // TODO: use this as ' bookmarking '
  // to be moved to someplace else
  // delete state.currentTopic;

  // delete state.interactionsSeen;
  // delete state.interactionsOpen;

  delete state.audioAcknowledged;
  delete state.audio;
  delete state.header;
  delete state.stndardHeader;
  delete state.graphicHeader;
  delete state.standardHeaderLogo;
  delete state.graphicHeaderBackground;
  delete state.graphicHeaderLogo;

  state.assessments = {};

  state.interactionsSeen = transformListFromIdToSId(
    state.idToSIdMap,
    state.interactionsSeen
  );

  state.interactionsLocked = transformListFromIdToSId(
    state.idToSIdMap,
    state.interactionsLocked
  );

  localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
};

export const clearState = () => {};

export const getState = (): State | undefined => {
  if (window.savedStore) {
    const s = { ...window.savedStore };
    if (s.theme && Object.keys(s.theme).length <= 0) {
      delete s.theme;
    }
    return s;
  }
  return undefined;
};

export const getLocalState = (): State => {
  let savedState = JSON.parse(localStorage.getItem('chameleon_v2')!) as State;
  if (savedState === null) {
    return {} as State;
  }

  const { sIdToIdMap } = savedState;

  let transformedInteractionsSeen: string[] = [];
  let transformedInteractionsLocked: string[] = [];

  if (savedState?.interactionsSeen?.length) {
    transformedInteractionsSeen = transformListFromSIdToId(
      sIdToIdMap,
      savedState.interactionsSeen as any
    );

    savedState.interactionsSeen = transformedInteractionsSeen;
  }

  if (savedState?.interactionsLocked?.length) {
    transformedInteractionsLocked = transformListFromSIdToId(
      sIdToIdMap,
      savedState.interactionsLocked as any
    );

    savedState.interactionsLocked = transformedInteractionsLocked;
  }

  return savedState;
  //
};

type Callable = () => void;

export const watch = (store: Store): Callable => {
  let deBounce;

  const unsubscribe = store.subscribe(() => {
    clearTimeout(deBounce);
    deBounce = setTimeout(saveState(store), 250);
  });

  return unsubscribe;
};
